import { NgxMatDateFormats, NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, ThemePalette } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { AppDateAdapter, APP_DATE_FORMATS } from '../../../core/format-datepicker';
import { PastHealthHistory, PastHealthHistoryObj } from '../../../core/models/patient/PastHealthHostoryQuestions';
import { Patient } from '../../../core/models/patient/patient';
import { PatientHealthHistory } from '../../../core/models/patient/PatientHealthHistory';
import { patientHealthSubType, patientHealthType } from '../../../core/models/patient/patientHealthType';
import { CommonService } from '../../../core/services/v2/common.service';
import { PatientService } from '../../../core/services/v2/patient.service';
import { WindowLoaderService } from '../../../shared/components/window-loader/window-loader.service';

export const MOMENT_DATETIME_WITH_MINUTES_FORMAT = 'MM/DD/YYYY, HH:mm';

// If using Moment
const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: MOMENT_DATETIME_WITH_MINUTES_FORMAT
  },
  display: {
    dateInput: MOMENT_DATETIME_WITH_MINUTES_FORMAT,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-patient-past-medical-history',
  templateUrl: './patient-past-medical-history.component.html',
  styleUrls: ['./patient-past-medical-history.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }]
})
export class PatientPastMedicalHistoryComponent implements OnChanges {
  @Input() editEnable: boolean;
  @Input() patientProfile: Patient;
  @Input() patientHealthHistories: PatientHealthHistory[];
  @Input() patientHealthTypes: patientHealthType[];
  @Input() healthHistoryQuestions: PastHealthHistory[];
  @ViewChild('#patientMedicalHistoryForm', null) patientMedicalHistoryForm: NgForm;
  pastHistoryData: PastHealthHistory[];

  patientHealthSubTypes: patientHealthSubType[];
  pastHealthHistoryObj: PastHealthHistoryObj[];
  maxDate: Date = new Date();

  dtPicker = {
    disabled: false,
    showSpinners: true,
    showSeconds: false,
    touchUi: false,
    enableMeridian: false,
    stepHour: 1,
    stepMinute: 1,
    stepSecond: 1
  }

  color: ThemePalette = 'primary';

  constructor(private patientService: PatientService,
    private router: ActivatedRoute,
    private loaderService: WindowLoaderService,
    private commonService: CommonService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.healthHistoryQuestions && this.healthHistoryQuestions.length > 0) {
      this.pastHistoryData = this.healthHistoryQuestions.filter(x => x.typeId == 1);
      if (this.patientHealthTypes && this.patientHealthHistories) {
        this.patientHealthSubTypes = this.patientHealthTypes.find(x => x.id == 1).healthSubTypes;
        this.mapPastHealthHistoryObj();
      }
    }
  }

  mapPastHealthHistoryObj() {
    this.pastHealthHistoryObj = [];
    for (var value of this.patientHealthSubTypes) {
      let data = null;
      let patientHealthHistoryId: number = 0;
      if (this.patientHealthHistories && this.patientHealthHistories.length > 0) {
        const patientHeathHisory = this.patientHealthHistories.find(x => x.typeId == value.typeId && x.subTypeId == value.id);
        if (patientHeathHisory) {
          patientHealthHistoryId = patientHeathHisory.id;
          const dataString = patientHeathHisory.healthData;
          if (dataString && dataString != '') {
            data = JSON.parse(dataString);
          }
        }
      }
      if (!data) {
        data = this.pastHistoryData.find(x => x.typeId == value.typeId && x.subTypeId == value.id).data;
      }
      let dataAvailable = "No";
      if (patientHealthHistoryId > 0) {
        dataAvailable = "Yes";
      }
      this.pastHealthHistoryObj.push({ patientHealthHistoryId: patientHealthHistoryId, dataAvailable: dataAvailable, typeId: value.typeId, subTypeId: value.id, subTypeName: value.name, healthData: data, showData: false, dataCount: 0 });
    }
  }

  saveDiseaseData(healthHistory: PastHealthHistoryObj, subTypeIndex: number) {
    console.log('healthDiseaseData ->', healthHistory);
    const healthData = JSON.stringify(healthHistory.healthData);
    const PatientHealthHistoryData: PatientHealthHistory[] = [{
      id: healthHistory.patientHealthHistoryId,
      patientId: this.patientProfile.id,
      typeId: healthHistory.typeId,
      subTypeId: healthHistory.subTypeId,
      healthData: healthData,
      subTypeName: null,
      typeName: null,
      active: true
    }];
    this.loaderService.blockWithLoader(this.patientService.savePatientHealthHistoryData(PatientHealthHistoryData)).subscribe(
      (details) => {
        if (details.isSuccess) {
          let data = this.pastHealthHistoryObj[subTypeIndex];
          data.dataAvailable = "Yes";
          this.pastHealthHistoryObj[subTypeIndex] = data;
          //todo refresh patientHealthHistoryId
        }
      },
      (error) => { console.error(error); }
    );
  }

  toggleCard(index: number) {
    let data = this.pastHealthHistoryObj;
    this.pastHealthHistoryObj[index].showData = !data[index].showData;
    //this.pastHealthHistoryObj = data;
  }

  attachReport(event, subTypeIndex: number, questionindex: number, healthHistory: PastHealthHistoryObj) {
    if (event.target.files && event.target.files[0]) {

      const file = event.target.files[0];

      if (!file.type.includes("image")) {
        alert('Please attach only Image file');
        return;
      }

      let patientReportFileForm = new FormData();
      patientReportFileForm.append('PatientId', this.patientProfile.id.toString());
      patientReportFileForm.append('ReportImageSource', file);
      patientReportFileForm.append('SubTypeName', healthHistory.subTypeName.replace(' ', ''));

      this.loaderService.blockWithLoader(this.patientService.uploadPatientMedicalHistoryReport(patientReportFileForm)).subscribe(
        (details) => {
          if (details.resultStatus.isSuccess) {
            healthHistory.healthData[0].qArr[questionindex].ans = details.result;
            this.pastHealthHistoryObj[subTypeIndex] = healthHistory;
          }
        },
        (error) => { console.error(error); this.loaderService.hide(); }
      );
    }
  }

  addOtherField(subTypeIndex: number, healthHistory: PastHealthHistoryObj, question: any) {
    healthHistory.healthData[0].qArr.push(
      {
        showEdit: true,
        editValue: "",
        qType: "edit",
        placeholder: "Medication name",
        class: "column"
      }
    );
    this.pastHealthHistoryObj[subTypeIndex] = healthHistory;
  }

  changeMultiSelect(event: any, question: any) {
    if (event.isUserInput) {
      let indexToUpdate = question.arr.findIndex(item => item.name === event.source.value);
      question.arr[indexToUpdate].value = !question.arr[indexToUpdate].value;
    }
  }
}
